import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { schema, schemaDefaultValues } from "./schema";
import { useContext, useEffect, useState } from "react";
import LibMask from "../../../../util/mask";
import { ContextRegisterClient } from "../context";
import Notification, { handleMessageError, handleMessageWarning } from "../../../toast";
import { ContextGlobal } from "../../../../context";
import LibBoolean from "../../../../util/libBool";
import reqCliente from "../../../../services/reqMultiTenant/reqCliente";
import reqTipoCliente from "../../../../services/reqMultiTenant/reqTipoCliente";
import { useAddress } from "../../../../hook/useAddress";

export const IndexHooks = (props) => {
	const { brazilStates, fetchCitiesByUf, loadingCities, listPermissionsData } = useContext(ContextGlobal);

	const { closeModalRegisterClient, isOpenModalRegisterClient, id_cliente, setClientsData, clientsData } =
		useContext(ContextRegisterClient);

	const [loading, setLoading] = useState(false);
	const [clientTypeData, setClientTypeData] = useState([]);
	const [sessionIdFuncionario] = useState(listPermissionsData?.id_funcionario);
	const [citiesData, setCitiesData] = useState([]);

	const {
		register,
		handleSubmit,
		setValue,
		setFocus,
		getValues,
		trigger,
		setError,
		reset,
		watch,
		control,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "onSubmit",
		//quando revalidar os campos
		resolver: zodResolver(schema),
		defaultValues: { ...schemaDefaultValues, id_funcionario: sessionIdFuncionario },
	});

	//#region Carregar Cliente
	const fetchClient = async () => {
		try {
			setLoading(true);

			if (id_cliente > 0) {
				const [responseClient, responseClientType] = await Promise.all([
					reqCliente.listID(id_cliente),
					reqTipoCliente.listAll(),
				]);

				// await fetchCities();
				setClientTypeData(responseClientType.data);
				if (
					responseClient.data &&
					typeof responseClient.data === "object" &&
					Object.keys(responseClient.data).length > 0
				) {
					const clientData = responseClient.data;
					const ativoValue = clientData.ativo === "SIM"; // Converte "SIM" para true, "NAO" para false
					const pessoafisica = clientData.pessoafisica === "SIM"; // Converte "SIM" para true, "NAO" para false
					clientData.ativo = ativoValue;
					clientData.pessoafisica = pessoafisica;
					if (clientData.cep === null) clientData.cep = "";

					Object.keys(clientData).forEach((field) => {
						setValue(field, clientData[field]);
					});
					await handleFetchCitiesByUf(clientData.uf);
				}
			} else {
				const lUF = listPermissionsData?.uf || "SP";
				const lId_Cidade = listPermissionsData?.id_cidade;

				setValue("uf", lUF);
				setValue("id_cidade", lId_Cidade);

				await Promise.all([reloadTypeClient(), handleFetchCitiesByUf(lUF)]);
			}
		} catch (error) {
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
			closeModalRegisterClient();
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (isOpenModalRegisterClient === true) {
			fetchClient();
		}
	}, [isOpenModalRegisterClient]);
	//#endregion

	//#region Buscar Cidades pelo estado
	const handleFetchCitiesByUf = async (uf) => {
		try {
			const responseCities = await fetchCitiesByUf(uf); // Aqui vai a função para buscar as cidades

			setCitiesData(responseCities);
		} catch (error) {
			handleMessageWarning(error.message);
		}
	};
	//#endregion

	//#region Selecionar estado e buscar as cidades
	const handleSelectedState = async (selectedOption) => {
		// quando selecionar o estado no input chama essa função
		await handleFetchCitiesByUf(selectedOption.value);
		setValue("id_cidade", "");
	};
	//#endregion

	//#region Pesquisar e preenche o endereço pelo cep
	const { handleFetchAddressByCep, cepIsSubmitting } = useAddress(setValue, setFocus, getValues);

	const handleFetchAddress = async () => {
		try {
			const uf = await handleFetchAddressByCep();
			handleFetchCitiesByUf(uf);
		} catch (error) {
			handleMessageWarning(error.message);
		}
	};
	//#endregion

	const telefone_1 = watch("telefone_1");
	useEffect(() => {
		setValue("telefone_1", LibMask.phone(telefone_1));
		if (telefone_1?.length !== 14) return;
	}, [telefone_1, setValue]);

	const telefone_2 = watch("telefone_2");
	useEffect(() => {
		setValue("telefone_2", LibMask.phone(telefone_2));
		if (telefone_2?.length !== 14) return;
	}, [telefone_2, setValue]);
	//#endregion

	//#region Salvar no banco
	const handleOnSubmit = async (data) => {
		try {
			const newAtivo = LibBoolean.booleanToStr(data.ativo);
			const newPessoaFisica = LibBoolean.booleanToStr(data.pessoafisica);

			const newDataClient = {
				...data,
				ativo: newAtivo,
				pessoafisica: newPessoaFisica,
			};

			//envia para o banco a requisição
			const responseInsertClient = await reqCliente.insert(newDataClient);
			//se deu certo o banco retorna o id do cliente que foi alterado ou inserido

			const currentIdClient = responseInsertClient.data.id_cliente;

			//recarrega a lista de clientes com as alterações
			await reloadClientData(currentIdClient);

			Notification.showToast({
				message: "Registro salvo com sucesso.",
				type: "success",
			});
		} catch (error) {
			Notification.showToast({
				message: "Erro ao atualizar tabela cliente. " + error.message,
				type: "error",
			});
		}
	};

	const reloadClientData = async (currentIdClient) => {
		try {
			try {
				//lista o cliente no qual foi feita a inserção ou alteração
				const responseClient = await reqCliente.listPaginate("id_cliente", currentIdClient, true, 1);

				//pego somente o primeiro pq neste caso mando sempre 1 resgistro por vez
				const responseClientData = responseClient.data[0];

				//se é inserção ou alteração. Inserção só adiciona mais um registro no array
				if (id_cliente === 0) {
					setClientsData((prevState) => [...prevState, responseClientData]);
				} else {
					//se for update ele procura na lista aonde ta o cliente que foi selecionado e altera somente ele
					const newClientData = clientsData.map((client) => {
						if (client.id_cliente === responseClientData.id_cliente) {
							return responseClientData;
						}
						return client;
					});
					setClientsData(newClientData);
				}
			} catch (error) {}
		} finally {
			reset();
			closeModalRegisterClient();
		}
	};
	//#endregion

	const handleCloseModal = () => {
		reset();
		closeModalRegisterClient();
	};

	const reloadTypeClient = async () => {
		try {
			const responseClientType = await reqTipoCliente.listAll();
			setClientTypeData(responseClientType.data);
		} catch (error) {
			handleMessageError("Erro ao  atualizar Tipo de cliente " + error.message);
		}
	};

	const insertTypeClient = async (data) => {
		const response = await reqTipoCliente.insert(data);
		return response;
	};

	return {
		//hook form
		errors,
		isSubmitting,
		register,
		setValue,
		control,
		handleSubmit,
		handleOnSubmit,

		//Data
		citiesData,
		clientTypeData,

		//variaveis de estado
		loading,
		loadingCities,
		cepIsSubmitting,

		//context
		isOpenModalRegisterClient,
		brazilStates,

		//funções
		handleSelectedState,
		handleFetchAddress,
		insertTypeClient,
		reloadTypeClient,
		handleCloseModal,
	};
};
